import api from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    transicaoFiltro: false,
  },

  getters: {
    list: (state) => state.list,
  },

  actions: {
    async find(_, {
      where, ...params
    } = {}) {
      const [{ data }, { data: { count: total } }] = await Promise.all([
        api.get('ordemservico', { params: { ...where, ...params } }),
        api.get('ordemservico/count', { params: where }),
      ]);

      return { data, total };
    },

    async findCardTotal(_, { where } = {}) {
      const { data } = await api.get('ordemservico/resumo/total', { params: where });
      return { data };
    },

    async findResumoDate(_, { where } = {}) {
      const { data } = await api.get('ordemservico/resumo/dia', { params: where });
      return { data };
    },

    async findResumoPessoa(_, { where } = {}) {
      const { data } = await api.get('ordemservico/resumo/pessoa', { params: where });
      return { data };
    },

    async findById(_, { id }) {
      const { data } = await api.get(`ordemservico/${id}`);
      return data;
    },
  },

  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_TRANSICAO(state, valor) {
      state.transicaoFiltro = valor ?? false;
    },
  },
};
